module.exports = __webpack_public_path__ + "img/wolfallstreets.36f30a46.png";